// extracted by mini-css-extract-plugin
export default {"qr-wrapper":"u08OP","qr":"zEBYg"};